import { updateViewTypeAction } from "./updateViewType.action";
import { MAP_CONFIG_LOADED } from "../../../../MapStore2/web/client/actions/config";
import { RootState } from "../../../rootState";
import { EpicFactory } from "../../../core/core-redux/reduxTypes";
import { Action } from "redux";

const getViewType = (state: RootState) => {
    if (state.changes.workspaceChanges.view) {
        return state.changes.workspaceChanges.view;
    } else if (state.urlParams.slots.haveSlotIds() && state.urlParams.viewType !== "base") {
        return "workspace";
    } else {
        return "base";
    }
};

export const viewTypeEpic: EpicFactory<Action, RootState, Action> = (action, store) =>
    action.ofType(MAP_CONFIG_LOADED).map(() => {
        const state = store.getState();

        return updateViewTypeAction(getViewType(state));
    });
